var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"end-box",style:({'background-image':("url(" + (require('@/assets/images/end.jpg')) + ")")})},[_c('span',[_vm._v("青田华侨技工学校欢迎您！")]),_vm._v(" "),_c('span',{staticClass:"end-span"},[_vm._v("网站正在维护中……")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-440fb04c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/end.vue
// module id = null
// module chunks = 